import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import config from 'utils/config';
import Avatar from '.';
function CoachAiAvatar(props) {
  return /*#__PURE__*/React.createElement(Avatar, _extends({
    shady: true
  }, props, {
    alt: "",
    icon: "sparkles",
    pictureUrl: config.styles.globals.aiCoachImageUrl
  }));
}
export default CoachAiAvatar;